import * as RadixPopover from '@radix-ui/react-popover';
import type { ReactNode } from 'react';

export interface PopoverProps {
  trigger: ReactNode;
  content: ReactNode;
  onOpenChange?: (open: boolean) => void;
  onInteractOutside?: (e: any) => void;
  preventFocusOnOpen?: boolean;
  open?: boolean;
  side?: RadixPopover.PopoverContentProps['side'];
}

export const Popover = ({
  trigger,
  content,
  onOpenChange,
  onInteractOutside,
  preventFocusOnOpen,
  open,
  side,
}: PopoverProps) => (
  <RadixPopover.Root onOpenChange={onOpenChange} open={open}>
    <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
    <RadixPopover.Portal>
      <RadixPopover.Content
        sideOffset={5}
        side={side}
        onInteractOutside={onInteractOutside}
        className="animate-in fade-in zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 isolate z-20 rounded bg-white p-5 shadow-lg will-change-[transform,opacity]"
        onOpenAutoFocus={(e) => {
          if (preventFocusOnOpen) {
            e.preventDefault();
          }
        }}
        onCloseAutoFocus={(e) => {
          e.preventDefault();
        }}
      >
        {content}
        <RadixPopover.Arrow className="fill-white" />
      </RadixPopover.Content>
    </RadixPopover.Portal>
  </RadixPopover.Root>
);

export const PopoverClose = RadixPopover.Close;
